<div class="row">
    <div class="col-12">
        <h4 class="fw-bold">{{ "user.create.title" | translate }}</h4>
    </div>
    <form class="col-12" [formGroup]="userForm">
        <div class="bg-card shadow-md rounded p-2 mb-3">
            <div class="row">
                <div class="col-12">
                    <adaa-form-input-file
                        label="breadcrumbs.user.profile_picture"
                        [isDisabled]="isViewMode()"
                        [onDeleteRemoveFile]="false"
                        [allowedFileSize]="100024"
                        [allowedFilesMessage]="profileFileMessage"
                        [allowedFiles]="allowedFiles"
                        [file]="profileFile"
                        (inputChanges)="onFilechange($event)"
                    />
                </div>
            </div>
        </div>

        <div class="bg-card shadow-md rounded p-2 mb-3">
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.username' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('username')?.invalid!"
                        formControlName="username"
                        controlName="username"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.email' | translate"
                        [setValidator]="formValidation()!"
                        [inputType]="'email'"
                        [invalid]="submitted && userForm.get('email')?.invalid!"
                        formControlName="email"
                        controlName="email"
                        (inputChanges)="userForm.get('username')!.setValue($event)"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.nameAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('nameAE')?.invalid!"
                        formControlName="nameAE"
                        controlName="nameAE"
                        [adaaSmartToolTips]="'users_tool_tip_name_ae'"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.nameEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('nameEN')?.invalid!"
                        formControlName="nameEN"
                        controlName="nameEN"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.jobTitleAE' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('jobTitleAE')?.invalid!"
                        formControlName="jobTitleAE"
                        controlName="jobTitleAE"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.jobTitleEN' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('jobTitleEN')?.invalid!"
                        formControlName="jobTitleEN"
                        controlName="jobTitleEN"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.directPhone' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('directPhone')?.invalid!"
                        [inputType]="'tel'"
                        formControlName="directPhone"
                        controlName="directPhone"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-input
                        [label]="'common.form.label.mobilePhone' | translate"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('mobilePhone')?.invalid!"
                        [inputType]="'tel'"
                        formControlName="mobilePhone"
                        controlName="mobilePhone"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        controlName="administrativeTitle"
                        formControlName="administrativeTitle"
                        [label]="'user.create.administrative_title' | translate"
                        [options]="administrativeTitles()"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('administrativeTitle')?.invalid!"
                        [clearable]="true"
                    />
                </div>
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <adaa-form-dropdown
                        controlName="entityId"
                        formControlName="entityId"
                        [label]="'common.form.label.entity' | translate"
                        [options]="entities()"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('entityId')?.invalid!"
                        (inputChanges)="onEntityChange($event)"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <adaa-form-dropdown-tree
                        controlName="orgUnitIds"
                        formControlName="orgUnitIds"
                        [label]="'common.form.label.position' | translate"
                        [options]="orgUnits()"
                        [setValidator]="formValidation()!"
                        [invalid]="submitted && userForm.get('orgUnitIds')?.invalid!"
                        [isMultiple]="true"
                        [adaaSmartToolTips]="'users_tool_tip_org_unit'"
                    />
                </div>
            </div>
            @if (userForm.get("entityId")?.value === Constants.CONSTANT_PMO_ID) {
                <div class="row">
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-dropdown-multi
                            controlName="enablerIds"
                            formControlName="enablerIds"
                            [clearable]="true"
                            [label]="'user.create.enabler_permissions' | translate"
                            [options]="enablerPermissions()"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && userForm.get('enablerIds')?.invalid!"
                        />
                    </div>
                    <div class="col-md-6 col-sm-12 col-xs-12">
                        <adaa-form-dropdown-multi
                            controlName="wtuaeIds"
                            formControlName="wtuaeIds"
                            [clearable]="true"
                            [label]="'user.create.wtuae_permissions' | translate"
                            [options]="wtuaePermissions()"
                            [setValidator]="formValidation()!"
                            [invalid]="submitted && userForm.get('wtuaeIds')?.invalid!"
                        />
                    </div>
                </div>
            }
            @if (AdaaHelper.isPMOEntity()) {
                <div class="row mt-2">
                    <div class="col-12 d-flex justify-content-center">
                        <adaa-form-checkbox
                            controlName="adaa4"
                            formControlName="adaa4"
                            [setDefaultValue]="userForm.get('adaa4')?.value"
                            [label]="'user.create.adaa4_login' | translate"
                        />
                    </div>
                </div>
            }
        </div>

        <div class="row mb-3">
            <div class="col-md-12">
                <div class="bg-card shadow-md rounded p-2">
                    <adaa-data-table
                        titleHeader="user.create.roles"
                        [useSmHeader]="true"
                        [required]="true"
                        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.USER_ROLES_LIST"
                        [isLocalData]="true"
                        [localData]="grants"
                        [enableViewAction]="false"
                        [enableEditAction]="false"
                        [enableAdd]="false"
                        [enableAdd]="!isViewMode()"
                        [enableDeleteAction]="!isViewMode()"
                        (addNewClicked)="addUserGrant()"
                        (actionClicked)="removeUserGrant($event)"
                        [adaaSmartToolTips]="'user_form_user_roles_conf_list_add_button'"
                    />
                </div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-md-12">
                <div class="bg-card shadow-md rounded p-2">
                    <adaa-data-table
                        titleHeader="user.create.groups"
                        [useSmHeader]="true"
                        [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.USER_GROUP_LIST"
                        [isLocalData]="true"
                        [localData]="groups"
                        [enableViewAction]="false"
                        [enableEditAction]="false"
                        [enableAdd]="false"
                        [enableAdd]="!isViewMode()"
                        [enableDeleteAction]="!isViewMode()"
                        (addNewClicked)="addUserGroups()"
                        (actionClicked)="removeUserGroup($event)"
                        [adaaSmartToolTips]="'user_form_user_groups_conf_list_add_button'"
                    />
                </div>
            </div>
        </div>

        @if (AdaaHelper.isPMOEntity()) {
            <div class="row mb-3">
                <div class="col-md-12">
                    <div class="bg-card shadow-md rounded p-2">
                        <adaa-data-table
                            titleHeader="user.create.responsibleFor"
                            [useSmHeader]="true"
                            [configKey]="Constants.MAIN_TABLE_LIST_CONF_KEY.USER_CONCERNED_ENTITIES_LIST"
                            [isLocalData]="true"
                            [localData]="responsiblities"
                            [enableViewAction]="false"
                            [enableEditAction]="false"
                            [enableAdd]="false"
                            [enableAdd]="!isViewMode()"
                            [enableDeleteAction]="!isViewMode()"
                            (addNewClicked)="addResponsibility()"
                            (actionClicked)="removeResponsibility($event)"
                        />
                    </div>
                </div>
            </div>
        }
    </form>
    <div class="col-12">
        <adaa-form-action-buttons
            saveButtonTitle="executive_teams.submit"
            [showSaveButton]="!isViewMode()"
            (saveClicked)="submit()"
            (cancelClicked)="cancel()"
        />
    </div>
</div>
